module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('div', {
    staticClass: "page-cover",
    on: {
      "click": _vm.showMenu
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fix-header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "nv-toolbar"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detail),
      expression: "!detail"
    }],
    staticClass: "header-menu",
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail),
      expression: "detail"
    }],
    staticClass: "go-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', {
    staticClass: "toolbar-nav-right",
    on: {
      "click": _vm.createTopic
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-list",
    class: {
      show: _vm.show
    },
    attrs: {
      "id": "sideBar"
    }
  }, [(_vm.user.loginname) ? _c('div', {
    staticClass: "user-info"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'User',
        params: {
          loginname: _vm.user.loginname
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v(_vm._s(_vm.user.loginname))]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" 退出 ")])], 1) : _c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    on: {
      "click": _vm.login
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("登录")])]), _vm._v(" "), _c('p', {
    staticClass: "menu-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-ul"
  }, _vm._l((this.menus), function(item, key) {
    return _c('router-link', {
      key: key,
      attrs: {
        "to": {
          name: 'Home',
          query: {
            tab: key
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    }), _vm._v(_vm._s(item.title))])
  })), _vm._v(" "), _c('p', {
    staticClass: "menu-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "about-info"
  }, [_c('a', {
    on: {
      "click": _vm.about
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v("关于")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-1a7c819e"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 149
// module chunks = 1